export default __webpack_public_path__ + "static/media/user-check-grey.6206fe7e.svg";